import { Ref, ref, useContext } from '@nuxtjs/composition-api';
import popularCategoriesGql from '~/modules/gomage/plugin-popular-categories/composables/usePopularCategories/popularCategories.gql';
import PopularCategories from "~/modules/gomage/plugin-popular-categories/components/PopularCategories.vue";

export interface PopularCategories {
  popular_category: {
    name: string
  }
}

export function usePopularCategories() {
  const { app } = useContext();
  const loading: Ref<boolean> = ref(false);

  const categories: Ref<Array<PopularCategories>> = ref([]);

  const loadCategories = async () => {

    try {
      loading.value = true;

      const { data } = await app.context.$vsf.$magento.api.customQuery({
        query: popularCategoriesGql,
      });
      categories.value = data?.categories?.items?.[0]?.popular_category ?? [];
    } catch (err) {
    } finally {
      loading.value = false;
    }
  };

  return {
    loadCategories,
    loading,
    categories,
  };
}

export default usePopularCategories;